<div class="modol_comp">
    <!-- HEADER -->
    <div class="modal-header pb-0 pt-0">
        <button type="button" class="button-close" mat-button aria-label="Close dialog" [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>

    <!-- BODY -->
    <div class="modal-body pt-0">
        <h2 mat-dialog-title class="dialog-title">
            Are you sure you want to update the package with Pro Rated Amount?
        </h2>

        <div mat-dialog-content class="dialog-body">
            <div class="breakdown-card">

                <div class="item-row" *ngIf="abs(this.data?.numberOfTrucks, this.data?.originalNumberOfTrucks) == 0 && this.data?.packageNotChanged">
                    <span class="red">
                        You are reducing the number of trucks from {{ this.data?.originalNumberOfTrucks }} to {{ this.data?.numberOfTrucks }}.
                    </span>
                </div>

                <!-- PACKAGE PRICE -->
                <div class="item-row" *ngIf="priceBreakdown?.packagePrice > 0">
                    <span class="label">Package Base Price</span>
                    <span class="value">
                        {{ priceBreakdown.packagePrice | currency:'USD' }}
                    </span>
                </div>

                <!-- TRUCK PRICE -->
                <div class="item-row" *ngIf="priceBreakdown?.trucksPrice > 0">
                    <span class="label">
                        Truck Charges
                        ({{ this.data?.packageNotChanged ? abs(this.data?.numberOfTrucks, this.data?.originalNumberOfTrucks) : this.data?.numberOfTrucks }} ×
                        {{
                        (proRatedAmounts?.proratedCost?.trucks / (this.data?.packageNotChanged ? abs(this.data?.numberOfTrucks, this.data?.originalNumberOfTrucks) : this.data?.numberOfTrucks))
                        | currency:'USD'
                        }})
                    </span>
                    <span class="value">
                        {{ priceBreakdown.trucksPrice | currency:'USD' }}
                    </span>
                </div>

                <!-- ADD-ONS TOTAL -->
                <div class="item-row" *ngIf="priceBreakdown?.addonsPrice > 0">
                    <span class="label">Add-Ons Total</span>
                    <span class="value">
                        {{ priceBreakdown.addonsPrice | currency:'USD' }}
                    </span>
                </div>

                <!-- ADD-ON BREAKDOWN -->
                <div class="addon-list mt-2" *ngIf="chargedAddOns?.length">
                    <div class="addon-row" *ngFor="let item of chargedAddOns">
                        <span class="addon-label">+ {{ item.label }}</span>
                        <span class="addon-price">
                            {{ item.price | currency:'USD' }}
                        </span>
                    </div>
                </div>

                <div class="divider" *ngIf="priceBreakdown?.total > 0"></div>

                <!-- FORMULA -->
                <div class="formula">
                    <mat-icon>calculate</mat-icon>
                    <span>
                        Cost Per Item ÷ Total Billing Cycle Days
                        {{ proRatedAmounts?.totalDaysInCycle }} days ×
                        Days Remaining {{ proRatedAmounts?.daysRemaining }} days
                    </span>
                </div>

                <!-- TOTAL -->
                <div class="item-row total">
                    <span class="label">Total Amount</span>
                    <span class="value">
                        {{ priceBreakdown?.total | currency:'USD' }}
                    </span>
                </div>

            </div>
        </div>
    </div>

    <!-- FOOTER -->
    <div class="modal-footer d-flex justify-content-between mt-3">
        <button type="button" class="btn cancel" [mat-dialog-close]="false">
            Cancel
        </button>

        <button type="button" class="btn delete" (click)="update()">
            Update
        </button>
    </div>
</div>